import ProductPageHero from "./ProductPageHero";

// Export types for external use
export type { RichSBData, SbImageWithMeta, SbRichTextIcon, InfoItem, ResourceAsset, Resource } from "./types";

export default ProductPageHero;
